import "./style.scss";

const Loader = () => {
  return (
    <div className="loader">
      <div className="loader__stars">
        {Array.from({ length: 60 }).map((_, i) => (
          <span key={i} className="loader__star" />
        ))}
      </div>
      <div className="loader__content">
        <div className="loader__moon" />
        <p className="loader__name">Antoine Gerard</p>
        <div className="loader__bar">
          <div className="loader__bar-fill" />
        </div>
      </div>
    </div>
  );
};

export default Loader;
